import React from "react";
import "../assets/css/common.css";
import { Flex } from "antd";

const Spinner: React.FC = () => (
  <Flex align="center" justify="center" style={{
    height: '100vh'
  }}>
    <div className="spinner" />
  </Flex>
);

export default Spinner;